import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var InfoLabelsBlock = styled.div.withConfig({
  displayName: "InfoLabelsBlock",
  componentId: "sc-18fr30x-0"
})(["display:flex;> span{margin-bottom:6px;margin-left:auto;margin-right:9px;}", ";"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-flow: column;\n\n    > span {\n      margin-right: 0;\n    }\n  "]))));